import { render } from "./InfoActiveBox.vue?vue&type=template&id=c4e5af4c&scoped=true&ts=true"
import script from "./InfoActiveBox.vue?vue&type=script&lang=ts"
export * from "./InfoActiveBox.vue?vue&type=script&lang=ts"

import "./InfoActiveBox.vue?vue&type=style&index=0&id=c4e5af4c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e5af4c"]])

export default __exports__